var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneRetro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4117 29.1084L32.977 23.6737C31.036 21.7327 27.7364 22.5092 26.96 25.0324C26.3778 26.7793 24.4368 27.7498 22.6899 27.3615C18.808 26.391 13.5675 21.3445 12.597 17.2685C12.0147 15.5216 13.1793 13.5807 14.9261 12.9985C17.4494 12.2221 18.2258 8.92245 16.2848 6.9815L10.8501 1.54683C9.29738 0.188165 6.96823 0.188165 5.60957 1.54683L1.92176 5.23464C-1.76605 9.11655 2.30995 19.4036 11.4324 28.5261C20.5549 37.6486 30.8419 41.9187 34.7239 38.0367L38.4117 34.3489C39.7704 32.7962 39.7704 30.467 38.4117 29.1084Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneRetro);
export default __webpack_public_path__ + "static/media/phone-retro.95a4e3b54bdd3ffdf3dd28649975a174.svg";
export { ForwardRef as ReactComponent };